import React from 'react';
import MuiLink from '@material-ui/core/Link';

import { Link as GatsbyLink } from 'gatsby';

const normalizeInternalPath = target => {
  if (typeof target !== 'string' || !target.startsWith('/')) {
    return target;
  }

  const [, pathname, suffix] = target.match(/^([^?#]*)(.*)$/) || [];
  if (!pathname || pathname === '/' || pathname.endsWith('/') || /\/[^/]+\.[^/]+$/.test(pathname)) {
    return target;
  }

  return `${pathname}/${suffix}`;
};

const Link = React.forwardRef(function Link(props, ref) {
  return <MuiLink component={GatsbyLink} ref={ref} {...props} to={normalizeInternalPath(props.to)} />;
});

export default Link;
